import { render } from "./SavedDashboardCards.vue?vue&type=template&id=3420936a"
import script from "./SavedDashboardCards.vue?vue&type=script&lang=js"
export * from "./SavedDashboardCards.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__